<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <data-table
    (detail)="onDetailCustomer($event)"
    [columns]="columnsCustomer"
    [dataProviderParams]="paramsCustomer"
    [dataProvider]="customerService"
    [hideSearch]=true
    title="Customers">
  </data-table>

  <div class="spacer"></div>

  <data-table
    (detail)="onDetailComposition($event)"
    [columns]="columnsComposition"
    [dataProviderParams]="paramsComposition"
    [dataProvider]="compositionService"
    [hideSearch]=true
    [title]="'Compositions'">
  </data-table>

  <div class="spacer"></div>

  <data-table
    (detail)="onDetailLegacyComposition($event)"
    [columns]="columnsLegacyComposition"
    [dataProviderParams]="paramsLegacyComposition"
    [dataProvider]="legacyCompositionService"
    [hideSearch]=true
    title="Legacy Compositons">
  </data-table>

  <div class="spacer"></div>

  <data-table (detail)="onDetailMetaImporter($event)"
                  *ngIf="connectedMetaImporter.length"
                  [columns]="columnsMetaImporter"
                  [hideSearch]=true
                  [plainData]="connectedMetaImporter"
                  title="Meta Importers">
  </data-table>

</page-content>
